export default "__VITE_ASSET__CWSeO1yT__"